var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4546,
    cy: 21.5455,
    r: 21.123,
    fill: "#D9FE72",
    fillOpacity: 0.07,
    stroke: "#D9FE72",
    strokeWidth: 0.84492
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4974 21.9679H26.2567V20.2781H19.4974V21.9679ZM19.4974 24.5027H26.2567V22.8129H19.4974V24.5027ZM19.4974 27.0375H23.722V25.3476H19.4974V27.0375ZM17.8075 29.5722C17.3428 29.5722 16.9451 29.4069 16.6145 29.0763C16.2838 28.7456 16.1182 28.3477 16.1177 27.8824V14.3637C16.1177 13.899 16.2833 13.5013 16.6145 13.1706C16.9457 12.84 17.3434 12.6744 17.8075 12.6738H24.5669L29.6364 17.7433V27.8824C29.6364 28.3471 29.4711 28.745 29.1404 29.0763C28.8098 29.4075 28.4118 29.5728 27.9466 29.5722H17.8075ZM23.722 18.5883V14.3637H17.8075V27.8824H27.9466V18.5883H23.722Z",
    fill: "#D9FE72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.0e20fa34efba17252e4cddce437ce372.svg";
export { ForwardRef as ReactComponent };